"use client";
import { RichTranslationValues } from "next-intl";
import { useEffect, useState } from "react";

export const modalRich = {
  div: (chunks) => (
    <div className="max-w-prose flex flex-col gap-1 text-justify">
      {chunks}
    </div>
  ),
  h2: (chunks) => (
    <h2 className="text-2xl font-bold text-left">
      {chunks}
    </h2>
  ),
  h3: (chunks) => (
    <h3 className="text-xl font-semibold mt-4 underline">
      {chunks}
    </h3>
  ),
  p: (chunks) => (
    <p className="text-base my-2">
      {chunks}
    </p>
  ),
  ul: (chunks) => (
    <ul className="list-disc list-outside pl-6 space-y-2">{chunks}</ul>
  ),
  li: (chunks) => (
    <li className="text-base">
      {chunks}
    </li>
  ),
  strong: (chunks) => (
    <strong className="font-extrabold">{chunks}</strong>
  ),
  br: () => (<><br /><br /></>),
} as RichTranslationValues

export default function ModalAsButton({ children, button, asButton, id }: { children: React.ReactNode; button: string, id: string, asButton?: boolean}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleKeyDown = (event: { key: string; }) => {
      if (event.key === 'Escape' || event.key === 'Enter') {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }
  , [isOpen]);

  return (
    <>
    {asButton ? (
      <button onClick={toggleModal}>{button}</button>
    ) : (
        <span className="underline font-bold hover:underline-offset-2 cursor-pointer" onClick={toggleModal}>{button}</span>
    )}
      {isOpen && (
        <div id={id} className="text-main font-medium antialiased text-left h-fit max-h-[75%] max-md:min-w-[75%] max-w-prose overflow-y-auto fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white bg-opacity-75 backdrop-blur-lg p-6 z-[1000] rounded-xl">
          {children}
        </div>
      )}
      {isOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-[999] overflow-hidden"
          onClick={toggleModal}
        ></div>
      )}
    </>
  );
}
